module.exports = __webpack_public_path__ + "static/media/ic_searchtype_beach.2f8576bc.svg";